'use client';

import { InputsNS } from '@/types/inputs';
import classNames from 'classnames';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { BsCheck, BsChevronRight } from 'react-icons/bs';
import { useClickAway } from 'react-use';
import { useInputStyle } from '../Inputs/_common';
import { InputWrap } from '../Inputs';
import { sendEventToGTM } from '@/helpers/gtm.helper';

type T_Props = {
	children?: ReactNode;
	id?: string;
	name?: string;
	options: {
		name: string;
		value: string;
	}[];
	label?: string;
	/** css class of Input Field content type */
	lableClassName?: string;
	/** label color */
	labelColor?: string;
	/** label size */
	labelSize?: string;
	/** label style */
	labelStyle?: any;

	disabled?: boolean;
	setSelectedValue: (e: string) => void;
	required?: boolean;
	className?: string;
	isValidInput?: boolean;
};

const DropdownMenu = (props: T_Props) => {
	const menuRef = useRef<HTMLDivElement | null>(null);
	const inputStyle = useInputStyle(InputsNS.StatusType.Informative);
	const [value, setValue] = useState(props.options.at(0)?.value || '');
	const [isOpen, setIsOpen] = useState(false);
	const [labelFontSize, setLabelFontSize] = useState<string>(`text-${props?.labelSize}`);

	const handleSelect = (newValue: string) => {
		//need to add logic for ctxFormSchema
		setValue(newValue as string);
		props.setSelectedValue(newValue as string)
	};

	useClickAway(menuRef, () => setIsOpen(false));

	const currentOption = props.options.find((option) => option.value === value);

	useEffect(() => {
		// setLabelFontColor(`text-[${props?.labelColor}]`);
		setLabelFontSize(`text-${props?.labelSize}`)
	}, [props?.labelColor, props?.labelSize])


	/* InputField GTM datalayer implementaion for interacting with the field*/

	const gtmDataLayerInputFiledInteracted = (e?: React.MouseEvent<HTMLDivElement>) => {

		const target = e?.currentTarget;
		const targetForm = target?.closest('form');
		const sessionFrmFlag = JSON.parse(sessionStorage?.getItem(`${targetForm?.id}_gtm_frm_flag`) || `{}`);

		if(sessionFrmFlag?.interactedField != props?.name){
			
			const currentStep = sessionFrmFlag?.nextStep || 1;
			sendEventToGTM({
				event: 'form_field_entered',
				formId: targetForm?.id,
				formName: targetForm?.name,
				formField: props?.name,
				formStepCount: currentStep,
            	pagePath: window.location.pathname,
				// location: 'modal',
				// section: 'hero_banner',
				type: 'form',
				subType: targetForm?.name
			},);
			sessionStorage?.setItem(`${targetForm?.id}_gtm_frm_flag`, JSON.stringify({...sessionFrmFlag, "nextStep" : currentStep + 1, interactedField: props?.name || "unknown"}));      // Set field interacted count as 1 to avoid spamming GTM
		}
			// console.log("GTM_event_called_for_this_field", target?.name);
	};
	return (
		<InputWrap
			label={props.label}
			lableClassName={props?.lableClassName}
			labelColor={props?.labelColor}
			labelSize={labelFontSize}
			labelStyle={props?.labelStyle}
			className="relative"
			required={props.required}
			htmlFor={props.id}
			disabled={props.disabled}
		>
			{/* <>value - {JSON.stringify(value)}</> */}
			<div
				ref={menuRef}
				id={props.id}
				className={classNames(
					'w-full h-input-height cursor-pointer bg-input-default-bg select-none text-input-default-text relative',
					{
						'rounded-t-input border-b-none': isOpen,
						'rounded-input': !isOpen,
					}
				)}
				onClick={(e) => { setIsOpen((prev) => !prev); !isOpen && gtmDataLayerInputFiledInteracted(e) }}>
				<div
					className={classNames(
						'flex items-center justify-between w-full gap-2 px-input-padding-x py-input-padding-y border-1 transition-all focus-border',
						{
							'rounded-t-input border-b-none': isOpen,
							'rounded-input': !isOpen,
						},
						{ '!bg-input-error-bg !text-input-error-text placeholder:!text-input-error-placeholder !border-input-error-border': !props?.isValidInput },
						inputStyle.border,
					)}>
					<p>{currentOption?.name || ''}</p>
					<BsChevronRight
						className={classNames('w-2 h-2 transition', {
							'rotate-90': isOpen,
						})}
						strokeWidth={2}
					/>
				</div>

				{true && (
					<div
						className={classNames(
							'absolute top-input-height bg-input-default-bg border-1 border-t-none1 w-full rounded-input py-[20px] transition top-0 focus-border',
							{
								'opacity-0 pointer-events-none -translate-y-1': !isOpen,
							},
							{ '!bg-input-error-bg !text-input-error-text placeholder:!text-input-error-placeholder !border-input-error-border': !props?.isValidInput },
							inputStyle.border,
						)}>
						{props.options?.map((option, index) => {
							return (
								<div
									className={classNames(
										'h-4 px-input-padding-x font-semibold hover:bg-base-light-brown flex items-center justify-between gap-0.5',
									)}
									key={option.value}
									onClick={() => handleSelect(option?.value || "")}>
									<div className='flex items-center gap-0.5'>
										{/* {option.name + ' - ' + option?.value} */}
										{option.name}
										{currentOption?.value === option.value && (
											<BsCheck className='w-3 h-3' />
										)}
									</div>
									{index === 0 &&
										<BsChevronRight
											className={classNames('w-2 h-2 transition', {
												'rotate-90': isOpen,
											})}
											strokeWidth={2}
										/>
									}
								</div>
							);
						})}
					</div>
				)}
				<div style={{ marginTop: "-50px", width: "100%" }}>{props?.children}</div>
			</div>
		</InputWrap>
	);
};

export default DropdownMenu;
